'use strict';

exports.__esModule = true;
exports.default = undefined;

var _Footer = require('./Footer');

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Footer2.default;
module.exports = exports['default'];